import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { TorchCameraService } from './torch-camera.service';
import { TorchCaptureBindings } from './torch-capture.model';
import { buildTorchCaptureVm, TorchCaptureVm } from './torch-capture-vm';

@Injectable()
export class TorchCapturePresenter {
  private readonly camera = inject(TorchCameraService);
  private readonly bindings = signal<TorchCaptureBindings | null>(null);
  private pinchStartZoom = 1;

  public readonly vm: Signal<TorchCaptureVm | null> = computed(() => {
    const bindings = this.bindings();
    return bindings ? buildTorchCaptureVm(this.camera.state(), bindings.copy()) : null;
  });

  public load(bindings: TorchCaptureBindings): void {
    this.bindings.set(bindings);
    this.camera.load(bindings);
  }

  public open(video: HTMLVideoElement): Promise<void> {
    return this.camera.open(video);
  }

  public toggleTorch(): Promise<void> {
    return this.camera.toggleTorch();
  }

  public capture(): Promise<void> {
    return this.camera.capture();
  }

  public cancel(): void {
    this.camera.cancel();
  }

  public startPinch(): void {
    this.pinchStartZoom = this.camera.state().zoom;
  }

  public pinchTo(scale: number): void {
    this.camera.setZoom(this.pinchStartZoom * scale);
  }
}
